import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type CtaButtonProps = {
  label: string;
  sublabel?: string;
  href?: string;
  size?: 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  label,
  sublabel,
  href = 'https://shop.ingridrosales.com/products/metodo-me-elijo',
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-5 text-base sm:text-lg' : 'px-6 py-3.5 text-sm sm:text-base';
  return <div className={`flex flex-col items-center ${className}`} data-id="element-38" data-mp="llh0x6smt0qk">
      <a href={href} className={`group inline-flex w-full max-w-md items-center justify-center gap-3 rounded-full bg-clay ${sizing} font-medium uppercase tracking-[0.12em] text-cream shadow-soft transition-all duration-300 hover:bg-plum focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-plum active:scale-[0.98]`} data-id="element-39" data-mp="lkxryfkylmoo">
        <span className="text-center leading-tight" data-id="element-40" data-mp="15areae4wn9li">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-id="element-41" data-mp="35xnzwvgqa4jw" />
      </a>
      {sublabel ? <p className="mt-3 text-center text-sm text-ink/60" data-id="element-42" data-mp="3ey411ya00zll">{sublabel}</p> : null}
    </div>;
}